<div ngModelGroup="comboSexo-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboSexo
                       nome="sexo-{{data}}"
                       [itens]="dados"
                       itemDescricao="descricao"
                       itemId="sigla"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Sexo"
                       label="Sexo"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
